import React, { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ProgressBar from 'react-bootstrap/ProgressBar';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import smoke from '../../../assets/images/smokeGasDpp.png';
import water from '../../../assets/images/waterDpp.jpeg';
import { getControlStyle, formatDecimalNumber } from '../../helper';

export function ProductImpact(props) {
  const { t } = useTranslation('common');

  const { fromForm, dataIndex, editingInput, deleteItem, dppAddEditAccess, sectionId, isProductArchived, setDppState, expColl } = props;
  const excludedKeys = ['waterUsageBreakDown', 'globalWarmingPotentialBreakdown', 'productImpactType', 'otherConfiguration'];
  const properties = props?.properties;

  const toggleDrop = () => {
    setDppState((otherStates) => ({
      ...otherStates,
      impactExp: !expColl?.impactExp,
    }));
  };

  useEffect(() => {
    if (props?.navigateId === 'product-impact-id') {
      setDppState((otherStates) => ({
        ...otherStates,
        navigateId: null,
        impactExp: true,
      }));
    }
  }, [props?.navigateId]);

  const hasNonEmptyValues = useMemo(() => {
    return Object.keys(properties).some((key) => {
      return !excludedKeys.includes(key) && properties[key] !== '';
    });
  }, [props?.properties]);

  const renderToggleIcon = () => {
    return (
      <span
        id="collapsible-impact"
        className={`icon-new-down-arrow-icon drop-icon ml-16 f-18 ${expColl?.impactExp ? 'rotated' : ''}`}
        onClick={() => toggleDrop()}
      />
    );
  };

  const productImpactData = props?.properties;
  const combinedStyles = getControlStyle(props?.otherConfiguration, 'alignment', 'colour', 'bold');
  const headerStyle = getControlStyle(props?.properties?.otherConfiguration, 'subHeadAlignment', 'subHeadColour', 'subHeadbold');

  const renderExpandView = () => {
    return (
      <div id="product-impact" className={expColl?.impactExp ? 'd-block' : 'd-none'}>
        <div className="co2" style={{ backgroundImage: `url(${smoke})` }}>
          <h3 className="title">Global Warming Potential</h3>
          <p>
            <span>{formatDecimalNumber(productImpactData?.globalWarmingPotential || 0)}</span> kg CO2e
          </p>
        </div>
        <div>
          {productImpactData?.globalWarmingPotentialBreakdown?.map((glo) => {
            return (
              <>
                <span className="title-breakdown">{props?.properties?.productImpactType === 'manual' ? glo?.title : 'AutoFill'}</span>
                <div className="progress-container">
                  <ProgressBar className="product-completion" now={glo.value} />
                  <span className="value">
                    {(() => {
                      if (!glo?.value) {
                        return '0%';
                      }
                      if (Number.isInteger(glo?.value)) {
                        return `${glo?.value}%`;
                      }
                      return `${formatDecimalNumber(glo?.value)}%`;
                    })()}
                  </span>
                </div>
              </>
            );
          })}
        </div>
        <p style={combinedStyles}>{productImpactData?.globalWarmingPotentialDescription}</p>

        <div className="water-usage-container" style={{ backgroundImage: `url(${water})` }}>
          <h3 className="title">Water usage</h3>
          <p>
            <span>{formatDecimalNumber(productImpactData?.waterUsage || 0)}</span>
            litres
          </p>
        </div>
        <div>
          {productImpactData?.waterUsageBreakDown?.map((glo) => {
            let displayValue = 0;

            if (glo?.value) {
              displayValue = formatDecimalNumber(glo.value);
            }

            return (
              <>
                <span className="title-breakdown">{props?.properties?.productImpactType === 'manual' ? glo?.title : 'AutoFill'}</span>
                <div className="progress-container">
                  <ProgressBar className="product-completion" now={glo.value} />
                  <span className="value">{displayValue}%</span>
                </div>
              </>
            );
          })}
        </div>
        <p style={combinedStyles}>{productImpactData?.waterUsageDescription}</p>
      </div>
    );
  };
  const renderEmptyandDataCase = () => {
    let content = null;
    if (!hasNonEmptyValues) {
      content = (
        <div className="empty-product-impact">
          <div className="placeholder">{t('DPP.CONTROL.PRODUCT_IMPACT.PRODUCT_IMPACT_PLACEHOLDER')}</div>
          <h3 className="main-title"> {t('DPP.CONTROL.PRODUCT_IMPACT.GLOBAL_WARMING_EMISSIONS')}</h3>
          <div className="global-warming">{t('DPP.CONTROL.PRODUCT_IMPACT.GLOBAL_WARMING_EMISSIONS')}</div>
          <h3 className="main-title"> {t('DPP.CONTROL.PRODUCT_IMPACT.WATER_USAGE')}</h3>
          <div className="water-usage">{t('DPP.CONTROL.PRODUCT_IMPACT.WATER_USAGE_PLACEHOLDER')}</div>
        </div>
      );
    } else {
      content = renderExpandView();
    }

    return content;
  };
  return (
    <div className="product-impact-control" id={sectionId}>
      {hasNonEmptyValues && (
        <div>
          <h3 className="main-title d-flex align-items-center">
            <span className="title-text">Product Impact</span>
            {renderToggleIcon()}
          </h3>
          <p className="f-16 mb-8" style={headerStyle}>
            {productImpactData?.subHeaderTitle}
          </p>
          <p id="product-impact-description" className={`${expColl?.impactExp ? 'full-view' : ''} fixed-description`} style={combinedStyles}>
            {productImpactData?.productImpactDescription}
          </p>
        </div>
      )}
      {renderEmptyandDataCase()}
      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default ProductImpact;
